import CafeteriaStatisticsSidebarFilterForm from './lib/filterForm';
import PanelBoxLayout from 'components/layout/panelBox';

import * as S from './styles';
import CafeteriaStatisticsSidebarExportDataForm from './lib/exportDataForm';
import * as T from 'common/types';
import dayjs from 'dayjs';

interface IProps {
  cafeteriaList: { list: T.Pages.CafeteriaListItem[] };
}

export default function CafeteriaStatisticsSidebar({ cafeteriaList }: IProps) {
  const now = dayjs().date(1);

  return (
    <S.Content>
      {/* The `maxWidth: 350` override is gone — the rail is 300px wide and the
          card fills it, rather than a card of one width inside a column of
          another. */}
      <PanelBoxLayout icon="/icons/stroke/filter.svg" title="Filter">
        <CafeteriaStatisticsSidebarFilterForm cafeteriaList={cafeteriaList} now={now} />
      </PanelBoxLayout>

      <PanelBoxLayout title="Export">
        <CafeteriaStatisticsSidebarExportDataForm />
      </PanelBoxLayout>
    </S.Content>
  );
}
